export const SalesHelp = ({props}) => {
    return <div style={{textAlign: 'left'}}>
        <p>
            <b>Invoice</b><br/>
            Invoices describe sales to customers.  They record the inventory sold to a customer. <br/>
            Invoice information includes the inventory quantity, sales price, and discount. <br />
            Payments and Refunds are also saved for each invoice.
        </p>
        <p>
            <b>Purchase Order</b><br/>
            Purchase Orders are similar to invoices, but with one major difference.  <br/>
            Purchase Orders include items that currently do not exist in inventory which have to be produced by the Fulfilment department.  <br/>
        </p>
        <p>
            <b>Purchase Order States</b><br/>
            POs have the following states which describes their current progress. <br />
            1) 'Created' - freshly created by the Sales Team. <br  />
            2) 'Fulfillment' - sent to the fulfillment team.  The sales team must set the PO to Fulfillment when it is ready to be processed. <br />
            3) 'Complete', - completed by fulfillment team.   The Fulfilment team must set the PO to Complete when all requested items have been fulfilled. <br />
            4) 'Verified' - marked as complete by the Sales team.   Once Verified, the PO behaves like a regular invoice. <br />
        </p>
    </div>
}